import React, {useContext, useEffect, useState} from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import Icon from '../ui-components/Icon';
import {
  book_title,
  chapterId,
  note,
  positionInBook,
  timestamp,
  verseRange,
} from '../../constants/stringsAndFields';
import {useTheme} from '../../theme/ThemeContext';
import globalStyle from '../../theme/globalStyle';
import DataContext from '../../context/dataContext';
import {convertTimeStampToString} from '../../utils/dateTime';
import {UIPressable} from '../ui-components/UIPressable';

const NoteItem = ({noteItem, onDeleteNote, onNoteClick}) => {
  const {getChapter} = useContext(DataContext);
  const [chapter, setChapter] = useState(null);
  const {theme} = useTheme();
  const global = globalStyle(theme);

  const handleDeleteClick = async e => {
    await onDeleteNote(noteItem, selectedVerseText);
  };

  const handleNoteClick = async _ => {
    onNoteClick(noteItem);
  };

  useEffect(() => {
    getChapter(noteItem[chapterId]).then(chapter => setChapter(chapter));
  }, []);

  const bookTitle = chapter?.[book_title] ?? '';
  const chapterNumber = chapter?.[positionInBook] ?? '';
  const verseRangeText =
    noteItem?.[verseRange]?.replaceAll('V', '')?.replaceAll(' ', '') ?? '';
  const selectedVerseText = `${bookTitle} ${chapterNumber}:${verseRangeText}`;

  return (
    <TouchableOpacity style={global.listItem} onPress={handleNoteClick}>
      <View style={global.listItemTextContainer}>
        <Text style={global.listItemTitle}>{selectedVerseText}</Text>
        <Text style={global.listItemContent}>{noteItem[note]}</Text>
        <Text style={global.listItemDate}>
          {convertTimeStampToString(noteItem[timestamp])}
        </Text>
      </View>
      <UIPressable onPress={handleDeleteClick} style={{padding: 5}}>
        <Icon name="trash" style={global.listItemIcon} />
      </UIPressable>
    </TouchableOpacity>
  );
};

export default NoteItem;
